import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { BoardWebAppHeader } from '#src/components/navigation/NewAppHeader/WebAppHeader/BoardWebAppHeader/index.tsx';

const Root = styled(Vertical)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  padding: var(--unit) var(--double-unit) var(--unit) var(--double-unit);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -80px;
    z-index: -1;
    background: linear-gradient(
      to bottom,
      rgba(var(--c-rgb-black), 1) 0%,
      rgba(var(--c-rgb-black), 0.5) 60%,
      transparent 100%
    );
    pointer-events: none;
  }

  @media ${desktopAndAbove} {
    padding: var(--unit) var(--double-unit) var(--unit) var(--double-unit);
  }
`;

export const ProBoardHeaderWrapper = ({ children }: PropsWithChildren) => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Root>
      {!isLaptopAndAbove && <BoardWebAppHeader />}
      {children}
    </Root>
  );
};
